import React from "react";
import Login from "../../components/home/auth/Login";

const LoginPage = () => {
  return (
    <>
      <Login />
    </>
  );
};

export default LoginPage;
